export const API_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000';
